import styled from 'styled-components';
import { media, mediaQuery } from '../../common/styles/styleUtil';

export const SimpleCarouselWrapper = styled.div`
  @media ${mediaQuery.tablet} {
    padding-left: 16px;
    padding-right: 0;
  }

  .slick-track {
    margin: 0;
    display: flex;

    .slick-slide {
      margin: 0 15px;

      @media (${mediaQuery.tablet}) {
        padding: 0 8px;
        margin: 0;
      }
      @media (${mediaQuery.mobile}) {
        padding: 2px 4px;
        margin: 0;
      }

      &:first-of-type {
        margin-left: 0;

        ${media.lg`
          padding-left: 0;
        `};
      }

      &:last-of-type {
        margin-right: 0;

        ${media.lg`
          padding-right: 16px;
        `};
      }
    }
  }

  .slick-arrow {
    overflow: hidden;
    border-radius: 50%;
    cursor: pointer;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
    height: 40px;
    position: absolute;
    top: 45%;
    width: 40px;
    z-index: 1;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: none;
    &:hover {
      background-color: #f7f8f9;
    }

    @media (${mediaQuery.tablet}) {
      display: none !important;
    }

    &.slick-disabled {
      opacity: 0;
    }

    &.slick-next {
      right: -18px;
      outline: none;
      text-align: center;
      font-size: 27px;
    }

    &.slick-prev {
      outline: none;
      left: -18px;
      text-align: center;
      font-size: 27px;
    }
  }
`;
